// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-actions {
  justify-content: center;
  column-gap: 1rem;
}
.modal-actions .button {
  height: 2rem;
  width: max-content;
  min-width: 5rem;
}`, "",{"version":3,"sources":["webpack://./src/app/components/analyze/query-name/query-name.component.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;EACA,gBAAA;AACJ;AACI;EACI,YAAA;EACA,kBAAA;EACA,eAAA;AACR","sourcesContent":[".modal-actions {\n    justify-content: center;\n    column-gap: 1rem;\n\n    .button {\n        height: 2rem;\n        width: max-content;\n        min-width: 5rem;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
